import React from 'react';
import './styles.css';

interface CustomSpinnerProps {
  spinning?: boolean;
  children?: React.ReactNode;
}

const CustomSpinner: React.FC<CustomSpinnerProps> = ({ spinning = false, children }) => {
  return (
    <div className="custom-spinner-container">
      {spinning && (
        <div className="custom-spinner-overlay">
          <div className="custom-spinner">
            <div className="custom-spinner-dot"></div>
            <div className="custom-spinner-dot"></div>
            <div className="custom-spinner-dot"></div>
          </div>
        </div>
      )}
      <div className={spinning ? 'custom-spinner-content-blur' : ''}>
        {children}
      </div>
    </div>
  );
};

export default CustomSpinner;
